<template>
  <div v-if="!isLegacy">not found error</div>
</template>

<script lang="ts">
import { isV1Legacy } from "@/state/appState";
import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    isLegacy(): boolean {
      return isV1Legacy.value;
    },
  },
});
</script>
